import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Button,
} from "reactstrap";
import "./OrderDetails.css";
import {
  FaChevronLeft,
  FaCheck,
  FaHourglassHalf,
  FaTimes,
} from "react-icons/fa";
import { useSelector } from "react-redux";
import CustomButton from "../../../components/CustomButton";

const OrderDetails = ({ onBack, statusUpdate, onCompletePayment }) => {
  const { selectedOrder } = useSelector((state) => state.orders);
  const [activeTab, setActiveTab] = useState("service");
  const islogin = useSelector((state) => state.user.isLogin);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const isPaymentCompleted = selectedOrder.paymentStatus === "COMPLETED";
  const isOrderApproved = selectedOrder.orderStatus === "APPROVED";
  const isOrderRejected = selectedOrder.orderStatus === "REJECTED";

  let paymentStepClass = "tracking-step";
  if (isPaymentCompleted) {
    paymentStepClass += " completed";
  } else {
    paymentStepClass += " current";
  }

  let approvalStepClass = "tracking-step";
  if (!isPaymentCompleted) {
    approvalStepClass += " pending";
  } else if (isOrderApproved) {
    approvalStepClass += " completed";
  } else if (isOrderRejected) {
    approvalStepClass += " rejected";
  } else {
    approvalStepClass += " current";
  }

  const approvalLabel = isOrderRejected ? "Order Rejected" : "Order Approval";

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  console.log(
    selectedOrder.paymentStatus === "PENDING" &&
      selectedOrder.createdBy === user.UserID,
    "paymentStatus"
  );
  console.log(
    selectedOrder.paymentStatus,
    selectedOrder.createdBy,
    user.UserID,
    "paymentStatus"
  );
  console.log(selectedOrder, "paymentStatus");
  // Parse the Photo string → array of URLs
  const photoUrls = (() => {
    try {
      if (selectedOrder.Photo) {
        return JSON.parse(selectedOrder.Photo);
      }
    } catch (e) {
      // sometimes it's already an array, sometimes a malformed string
      return [];
    }
    return [];
  })();

  // Parse packageDetails (it's a JSON string)
  const packageInfo = (() => {
    try {
      if (selectedOrder.packageDetails) {
        return JSON.parse(selectedOrder.packageDetails);
      }
    } catch (e) {
      return null;
    }
    return null;
  })();
  return (
    <Container className="order-details-container">
      <CustomButton
        onClick={onBack}
        type="default_gradient"
        icon={FaChevronLeft}
        title="Back to Orders"
        // className="order-details-back-button"
      >
        Back to Orders
      </CustomButton>
      <h2 className="order-details-title">
        Order Details - ID: {selectedOrder.Id}
      </h2>
      <Row>
        <Col md={12}>
          <Card className="order-details-card">
            <CardBody>
              {/* <h4 className="order-details-card-title">Order Information</h4> */}
              <Nav tabs className="order-details-tabs">
                <NavItem>
                  <NavLink
                    className={activeTab === "service" ? "active" : ""}
                    onClick={() => toggleTab("service")}
                  >
                    Service Details
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={activeTab === "package" ? "active" : ""}
                    onClick={() => toggleTab("package")}
                  >
                    Package Details
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={activeTab === "payment" ? "active" : ""}
                    onClick={() => toggleTab("payment")}
                  >
                    Payment Details
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={activeTab === "parties" ? "active" : ""}
                    onClick={() => toggleTab("parties")}
                  >
                    Provider & Customer
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={activeTab}>
                <TabPane tabId="service">
                  <div className="order-details-section">
                    <div className="order-details-item">
                      <b>Service:</b> {selectedOrder?.serviceName || "N/A"}
                    </div>
                    <div className={"order-details-item"}>
                      <b>Order Status:</b>{" "}
                      <span
                        className={
                          isOrderRejected
                            ? "tracking-rejected"
                            : isOrderApproved
                            ? "tracking-approved"
                            : isPaymentCompleted
                            ? "tracking-awaiting-approval"
                            : "tracking-payment-pending"
                        }
                      >
                        {isOrderRejected
                          ? "ORDER REJECTED"
                          : isOrderApproved
                          ? "ORDER APPROVED"
                          : isPaymentCompleted
                          ? "AWAITING APPROVAL"
                          : "PAYMENT PENDING"}
                      </span>
                    </div>
                    <div className="order-details-item">
                      <b>Created At:</b>{" "}
                      {selectedOrder?.createdAt
                        ? new Date(selectedOrder.createdAt).toLocaleDateString(
                            "en-US"
                          )
                        : "N/A"}
                    </div>
                    <div className="order-details-item">
                      <b>Event Date:</b>{" "}
                      {selectedOrder?.reserveDate
                        ? new Date(
                            selectedOrder.reserveDate
                          ).toLocaleDateString("en-US")
                        : "N/A"}
                    </div>
                    <div className="order-details-item">
                      <b>Event Time:</b>{" "}
                      {selectedOrder?.startTime
                        ? new Date(
                            `1970-01-01T${selectedOrder.startTime}`
                          ).toLocaleTimeString("en-US", {
                            hour: "numeric",
                            minute: "2-digit",
                            hour12: true,
                          })
                        : "N/A"}
                    </div>

                    <div className="order-details-item">
                      <b>Message:</b>{" "}
                      {selectedOrder?.Message || "No message provided"}
                    </div>
                    <div className="order-details-item">
                      <b>Deal Term:</b> {selectedOrder?.dealTerm || "N/A"}
                    </div>
                    <div className="order-details-item">
                      <b>About Appointment:</b>{" "}
                      {selectedOrder?.aboutAppointment || "N/A"}
                    </div>
                  </div>
                </TabPane>
                <TabPane tabId="package">
                  <div className="package-details-section">
                    {packageInfo ? (
                      <Card className="package-details-card shadow-sm border-0">
                        <CardBody className="p-4">
                          <h5 className="package-title mb-3">
                            {packageInfo.title}
                          </h5>

                          {packageInfo.description && (
                            <p className="text-muted mb-4">
                              {packageInfo.description}
                            </p>
                          )}

                          {/* Responsive Table */}
                          <div className="table-responsive">
                            <table className="table table-hover align-middle">
                              <thead className="table-light">
                                <tr>
                                  <th style={{ width: "30%" }}>Item</th>
                                  <th>Description</th>
                                  <th
                                    className="text-end"
                                    style={{ width: "15%" }}
                                  >
                                    Price
                                  </th>
                                  <th
                                    className="text-center"
                                    style={{ width: "15%" }}
                                  >
                                    Units
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {packageInfo.packages
                                  .filter((pkg) => pkg.checked)
                                  .map((pkg, idx) => (
                                    <tr key={idx}>
                                      <td>
                                        <strong className="text-primary">
                                          {pkg.title}
                                        </strong>
                                      </td>
                                      <td className="text-muted small">
                                        {pkg.description || "—"}
                                      </td>
                                      <td className="text-end fw-bold">
                                        ${parseFloat(pkg.price || 0).toFixed(2)}
                                      </td>
                                      <td className="text-center text-muted">
                                        {pkg.units || "—"}
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          </div>

                          {/* Total Price Footer */}
                          <div className="package-total-footer mt-4 p-3 bg-light rounded">
                            <Row className="align-items-center">
                              <Col>
                                <h6 className="mb-0">Total Package Price</h6>
                              </Col>
                              <Col xs="auto">
                                <h4 className="mb-0 text-success fw-bold">
                                  $
                                  {parseFloat(
                                    packageInfo.totalPrice || 0
                                  ).toFixed(2)}
                                </h4>
                              </Col>
                            </Row>
                          </div>

                          {packageInfo.guestCount && (
                            <div className="mt-3 text-center text-muted small">
                              For {packageInfo.guestCount} guests
                            </div>
                          )}
                        </CardBody>
                      </Card>
                    ) : (
                      <Card className="text-center p-5">
                        <p className="text-muted mb-0">
                          No package details available
                        </p>
                      </Card>
                    )}
                  </div>
                </TabPane>
                <TabPane tabId="payment">
                  <div className="order-details-section">
                    <div className="order-details-item">
                      <b>Actual Price:</b> $
                      {parseFloat(selectedOrder.totalAmount || 0).toFixed(2)}
                    </div>
                    <div className="order-details-item">
                      <b>Discount:</b> $
                      {parseFloat(selectedOrder.Discount || 0).toFixed(2)}
                    </div>
                    <div className="order-details-item">
                      <b>Total Amount:</b> $
                      {parseFloat(
                        selectedOrder.totalAmount - selectedOrder.Discount || 0
                      ).toFixed(2)}
                    </div>
                    <div className="order-details-item">
                      <b>Paid Amount:</b> $
                      {parseFloat(selectedOrder.paidAmount || 0).toFixed(2)}
                    </div>
                    {/* <div className="order-details-item">
                      <b>Final Price:</b> $
                      {parseFloat(selectedOrder.paidAmount || 0).toFixed(2)}
                    </div> */}
                  </div>
                </TabPane>
                <TabPane tabId="parties">
                  <div className="order-details-section">
                    <h5 className="order-details-subsection-title">
                      Provider Details
                    </h5>
                    <div className="order-details-item">
                      <b>Name:</b> {selectedOrder.providerName || "N/A"}
                    </div>
                    {/* <div className="order-details-item">
                      <b>Contact:</b> {selectedOrder.provider?.contact || "N/A"}
                    </div>
                    <div className="order-details-item">
                      <b>Email:</b> {selectedOrder.provider?.email || "N/A"}
                    </div> */}
                    <h5 className="order-details-subsection-title">
                      Customer Details
                    </h5>
                    <div className="order-details-item">
                      <b>Name:</b>{" "}
                      {selectedOrder.customerName ||
                        selectedOrder.userName ||
                        "N/A"}
                    </div>
                    {/* <div className="order-details-item">
                      <b>Contact:</b> {selectedOrder?.Phone || "N/A"}
                    </div>
                    <div className="order-details-item">
                      <b>Email:</b> {selectedOrder?.Email || "N/A"}
                    </div> */}
                  </div>
                </TabPane>
              </TabContent>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row className="mt-1">
        <Col md={12}>
          <Card className="order-details-card">
            <CardBody>
              <h4 className="order-details-card-title">Order Tracking</h4>
              <div className="order-tracking-timeline">
                <ul className="tracking-steps">
                  <li className="tracking-step completed">
                    <div className="step-circle">
                      <FaCheck />
                    </div>
                    <p>Order Placed</p>
                  </li>
                  <li className={paymentStepClass}>
                    <div className="step-circle">
                      {isPaymentCompleted ? <FaCheck /> : <FaHourglassHalf />}
                    </div>
                    <p>Payment Pending</p>
                  </li>
                  <li className={approvalStepClass}>
                    <div className="step-circle">
                      {isOrderApproved ? (
                        <FaCheck />
                      ) : isOrderRejected ? (
                        <FaTimes />
                      ) : (
                        <FaHourglassHalf />
                      )}
                    </div>
                    <p>{approvalLabel}</p>
                  </li>
                </ul>
                <div className="tracking-actions">
                  {selectedOrder.paymentStatus === "PENDING" &&
                    selectedOrder.createdBy === user.UserID && (
                      // <Button
                      //   className="tracking-action-button complete-payment"
                      //   onClick={(e) => {
                      //     e.stopPropagation(); // Prevent triggering handleOrderClick
                      //     onCompletePayment(selectedOrder);
                      //   }}
                      // >
                      //   Complete Payment
                      // </Button>
                      <CustomButton
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent triggering handleOrderClick
                          onCompletePayment(selectedOrder);
                        }}
                        type="default_gradient"
                        icon={FaCheck}
                        title="Complete Payment"
                        className=""
                      >
                        Complete Payment
                      </CustomButton>
                    )}
                  {selectedOrder.orderStatus === "PENDING" &&
                    selectedOrder.paymentStatus === "COMPLETED" &&
                    selectedOrder.ownerId == user.UserID && (
                      <div className="tracking-action-buttons">
                        <Button
                          className="tracking-action-button approve"
                          onClick={(e) =>
                            statusUpdate(e, selectedOrder, "APPROVED")
                          }
                        >
                          Approve
                        </Button>
                        <Button
                          className="tracking-action-button reject"
                          onClick={(e) =>
                            statusUpdate(e, selectedOrder, "REJECTED")
                          }
                        >
                          Reject
                        </Button>
                      </div>
                    )}
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row className="mt-1">
        <Col md={12}>
          <h4 className="order-details-card-title">Images</h4>
          {photoUrls.length > 0 ? (
            <Row className="order-details-image-gallery">
              {photoUrls.map((url, i) => (
                <Col xs={6} md={4} lg={3} key={i} className="mb-4">
                  <div className="image-wrapper">
                    <img
                      src={url}
                      alt={`Order photo ${i + 1}`}
                      className="img-fluid rounded shadow-sm order-details-image"
                      style={{
                        width: "100%",
                        height: "200px",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                </Col>
              ))}
            </Row>
          ) : (
            <p className="text-muted">No images uploaded for this order.</p>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default OrderDetails;
